import { Goal, Dribbble, Gamepad2, Zap, Spade, Newspaper } from "lucide-react";
import { Reveal } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

export default function ContentStrip() {
  const { t } = useLanguage();
  const ITEMS = [
    { key: "scope1", Icon: Goal },
    { key: "scope2", Icon: Dribbble },
    { key: "scope3", Icon: Gamepad2 },
    { key: "s1Title", Icon: Zap },
    { key: "s3Title", Icon: Spade },
    { key: "s4Title", Icon: Newspaper },
  ];
  return (
    <div data-testid="content-strip" className="px-6 pb-1 pt-3">
      <Reveal>
        <div className="grid grid-cols-3 gap-2 rounded-2xl border border-[rgba(22,99,230,0.12)] bg-white px-3 py-3 shadow-[0_10px_28px_-16px_rgba(11,61,145,0.3)] sm:grid-cols-6">
          {ITEMS.map((item, i) => (
            <div key={item.key} className="flex flex-col items-center text-center" data-testid={`content-strip-item-${i + 1}`}>
              <span
                className={`flex h-8 w-8 items-center justify-center rounded-full ${
                  i === 4 ? "bg-[rgba(242,183,5,0.14)] text-[#B8860B]" : "bg-[rgba(22,99,230,0.08)] text-[#1663E6]"
                }`}
              >
                <item.Icon className="h-[15px] w-[15px]" strokeWidth={2} />
              </span>
              <p className="mt-1.5 text-[10px] font-medium leading-tight text-[#0F1E3D]">{t(item.key)}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  );
}
